import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useForm } from 'react-hook-form';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import 'dayjs/locale/ko';
import EstimatePreview from '../../views/admin/EstimatePreview';

const COUPON_PRICE = 200000;

export default function ActiveCodeApplication(props) {
  const auth = useRecoilValue(authAtom);
  const { username, companyName, companyNo, eMail, cellPhoneNumber } = auth;

  const {
    handleSubmit,
    register,
    clearErrors,
    reset,
    formState: { errors, isDirty, isSubmitting }
  } = useForm({
    defaultValues: {
      username: username,
      companyName: companyName,
      cellPhoneNumber: cellPhoneNumber,
      eMail: eMail,
      companyNo: companyNo
    }
  });

  const { ref: fileRef, onChange: onFileChange, ...fileRest } = register('datas.businessRegist');

  const { open, handleClose } = props;
  const [buyQuantity, setBuyQuantity] = useState(1);
  const [amount, setAmount] = useState(COUPON_PRICE);
  const [estimateInfo, setEstimateInfo] = useState({});
  const [openEstimate, setOpenEstimate] = useState(false);

  const handleChange = (e) => {
    if (e.target.value <= 0) {
      alert('구매 수량은 0보다 작을수 없습니다.');
      return;
    }
    setAmount(COUPON_PRICE * e.target.value);
    setBuyQuantity(e.target.value || 1);
  };
  const handleOpenEstimate = async (data) => {
    const info = {};

    info.companyName = data.companyName;
    info.companyNo = data.companyNo;
    info.userid = auth.userid;
    info.username = data.username;
    info.cellPhoneNumber = data.cellPhoneNumber;
    info.eMail = data.eMail;
    info.quantity = data.quantity;
    info.totalAmount = (data.quantity * COUPON_PRICE).toLocaleString('en-US');
    info.sumAmount = (data.quantity * COUPON_PRICE).toLocaleString('en-US');
    info.vatAmount = (data.quantity * COUPON_PRICE * 0.1).toLocaleString('en-US');
    info.depositAmount = (data.quantity * COUPON_PRICE + data.quantity * COUPON_PRICE * 0.1).toLocaleString('en-US');

    setEstimateInfo(info);
    setOpenEstimate(true);
  };

  const onSubmit = async (data) => {
    if (!isSubmitting) {
      await handleOpenEstimate(data);
    }
  };

  useEffect(async () => {
    if (open) {
      setBuyQuantity(1);
      setAmount(COUPON_PRICE);
      clearErrors();
      reset();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
        <DialogTitle id="draggable-dialog-title">견적서 받기</DialogTitle>
        <DialogContent dividers>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>회사</TableCell>
                  <TableCell>
                    {companyName} ({companyNo})
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>담당자</TableCell>
                  <TableCell>{username}</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell>구매 수량</TableCell>
                  <TableCell colSpan={2}>
                    <TextField
                      id="count"
                      type="number"
                      variant="outlined"
                      size="small"
                      sx={{ width: 200 }}
                      inputProps={{ defaultValue: 1, min: 1, max: 300, style: { textAlign: 'right' }, pattern: '[0-9]*' }}
                      autoFocus
                      value={buyQuantity || 1}
                      error={!!errors.quantity}
                      helperText={errors.quantity && errors.quantity.message}
                      {...register('quantity', {
                        required: '쿠폰 수량을 입력해주세요.'
                      })}
                      onChange={handleChange}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>총 금액</TableCell>
                  <TableCell>
                    {[Math.floor(COUPON_PRICE * buyQuantity)].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                    <Typography variant="body2" display="inline" gutterBottom sx={{ ml: 1, color: 'red' }}>
                      (VAT 별도)
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>최종 금액</TableCell>
                  <TableCell>{[Math.floor(amount + amount * 0.1)].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={2}>
                    <Typography variant="h6">견적서 받을 담당자</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>회사명</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.companyName}
                      helperText={errors.companyName && errors.companyName.message}
                      fullWidth
                      {...register('companyName', {
                        required: '견적서를 받을 회사명을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>이름</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.username}
                      helperText={errors.username && errors.username.message}
                      fullWidth
                      {...register('username', {
                        required: '견적서를 받을 담당자명을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>전화번호</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.cellPhoneNumber}
                      helperText={errors.cellPhoneNumber && errors.cellPhoneNumber.message}
                      fullWidth
                      {...register('cellPhoneNumber', {
                        required: '견적서를 받을 담당자 핸드폰번호를 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>견적서 이메일</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      error={!!errors.eMail}
                      helperText={errors.eMail && errors.eMail.message}
                      fullWidth
                      {...register('eMail', {
                        required: '견적서를 받을 담당자 이메일을 입력해주세요.'
                      })}
                    />
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <span style={{ fontSize: 'small', margin: '10px 10px 0px 10px' }}>※ 문의사항은 swmaster@dohwa.co.kr으로 보내주시면 답변드리겠습니다.</span>
          <EstimatePreview open={openEstimate} setOpenEstimate={setOpenEstimate} estimateInfo={estimateInfo} modalClose={handleClose} />
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" color="primary">
            견적 받기
          </Button>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
